import { useState, useEffect } from "react";
import axios from "axios";
import useAxiosConfig from "../config/useAxiosConfig";

const useFetchXCSI = () => {
  const { loading: axiosLoading, error } = useAxiosConfig();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const resp = await axios.get("/CcpExportXCSI");
        const d = resp.data;
        // API may return array or { rows: [...] }
        let rows = [];
        if (Array.isArray(d)) rows = d;
        else if (d && Array.isArray(d.rows)) rows = d.rows;
        else if (d && Array.isArray(d.result)) rows = d.result;

        // Stamp each row with a guaranteed-unique id so DataGridPro
        // never de-duplicates rows (Tartan_Id is an instructor id,
        // not a unique row identifier).
        setData(rows.map((row, idx) => ({ ...row, _rowId: `row-${idx}` })));
      } catch (err) {
        console.error("useFetchXCSI error:", err);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    if (!axiosLoading) fetchData();
  }, [axiosLoading]);

  return { data, loading };
};

export default useFetchXCSI;
